"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var tasks_1 = require("../redux/tasks");
var Button_1 = require("./Button");
var CreateTask_1 = require("./CreateTask");
var ItemsMenu_1 = require("./ItemsMenu");
require("./style/TasksMenu.css");
var TaskTag_1 = require("./TaskTag");
var TasksMenu = /** @class */ (function (_super) {
    __extends(TasksMenu, _super);
    function TasksMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TasksMenu.prototype.render = function () {
        var _a = this.props, currentTag = _a.currentTag, setCurrentTag = _a.setCurrentTag, tags = _a.tags;
        return (React.createElement(ItemsMenu_1.default, __assign({}, this.props, { createItem: React.createElement(CreateTask_1.default, null) }), tags.length !== 0 &&
            React.createElement("div", { className: "TasksMenu-tags" },
                React.createElement("div", { className: "TasksMenu-tags-title" }, "tags"),
                tags.map(function (tag, index) {
                    return React.createElement(TaskTag_1.default, { key: index, tag: tag, highlighted: currentTag === null ? null : tag === currentTag, onClick: function () { return setCurrentTag(tag === currentTag ? null : tag); } });
                }),
                React.createElement(Button_1.default, { className: "TasksMenu-no-tag-button" +
                        (currentTag === "" ? "-highlighted" : ""), onClick: function () { return setCurrentTag(currentTag === "" ? null : ""); } }, "none"))));
    };
    return TasksMenu;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var tasks = _a.tasks;
    return tasks;
}, tasks_1.actionCreators)(TasksMenu);



//////////////////
// WEBPACK FOOTER
// ./src/component/TasksMenu.tsx
// module id = 706
// module chunks = 0